// extracted by mini-css-extract-plugin
module.exports = {"ranking-card":"listCard_ranking-card__HeMNQ","spacer":"listCard_spacer__gvlOw","category":"listCard_category__CjTpq","content":"listCard_content__v9MR7"};